import React from 'react'
import PAGE_TITLES from '../../consts/titles'
import CustomHeader from '../../components/CustomHeader'
import SkipNavigation from '../../components/SkipNavigation'
import QrcodeFeature from '../../features/QrcodeFeature'

const QrcodePage: React.FC = (): JSX.Element => {
  return (
    <>
      <SkipNavigation />
      <QrcodeFeature/>
    </>
  )
}

export default QrcodePage
